// extracted by mini-css-extract-plugin
export default {"Title":"AutomationTiles_Title__Jiekg","TileContainer":"AutomationTiles_TileContainer__GfS-V","Tile":"AutomationTiles_Tile__d3Y4b"};